import React from 'react';
import { string, number, object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import {
    buildSellerCardAboutMeSkillTestsEvent,
    buildSellerCardAboutMeSkillTestsScoreEvent,
    buildSellerCardAboutMeSkillTestsScoreLabelEvent
} from './biData';

export default function Test({ title, score, status, biData }) {
    const scoreFragment = score / 10;
    const statusClassname = `status ${status}`;

    return (
        <li>
            <WithImpressions value={buildSellerCardAboutMeSkillTestsEvent(biData, title)}
                element="span">{title}</WithImpressions>

            <WithImpressions value={buildSellerCardAboutMeSkillTestsScoreEvent(biData, scoreFragment)}
                element="strong">{scoreFragment}<small>/10</small></WithImpressions>

            <WithImpressions value={buildSellerCardAboutMeSkillTestsScoreLabelEvent(biData, status)}
                element="span" className={statusClassname}>
                <I18n k={`user_page_perseus.seller_profile.skill_status.${status}`}/>
            </WithImpressions>
        </li>
    );
}

Test.propTypes = {
    title: string,
    score: number,
    status: string,
    biData: object
};

Test.defaultProps = {
    title: '',
    score: 0,
    status: '',
    biData: {}
};
